import { Timer } from "lucide-react";

const fmt = (s) => {
  const a = Math.abs(s);
  return `${s < 0 ? "-" : ""}${Math.floor(a / 60)}:${String(a % 60).padStart(2, "0")}`;
};

export const VivaTimer = ({ remaining, phaseLabel, phaseRemaining }) => {
  const color = remaining <= 60 ? "var(--alert)" : remaining <= 180 ? "var(--warn)" : "var(--ok)";
  return (
    <div
      data-testid="viva-timer"
      className="fixed top-16 right-3 sm:right-6 z-40 card px-4 py-2.5 shadow-lg min-w-[150px]"
      style={{ borderColor: color }}
    >
      <div className="flex items-center gap-2">
        <Timer size={16} style={{ color }} className={remaining <= 60 ? "animate-pulse" : ""} />
        <span data-testid="viva-timer-countdown" className="font-mono font-bold text-2xl tracking-wider" style={{ color }}>
          {fmt(Math.max(remaining, 0))}
        </span>
      </div>
      <div className="text-[11px] mt-0.5 flex justify-between gap-3" style={{ color: "var(--ink-3)" }}>
        <span>{phaseLabel}</span>
        <span data-testid="viva-phase-remaining" className="font-mono" style={{ color: phaseRemaining < 0 ? "var(--alert)" : undefined }}>
          {fmt(phaseRemaining)}
        </span>
      </div>
    </div>
  );
};
